import { Grid } from '@material-ui/core';
import { InfoCard } from '@backstage/core-components';
import { Entity, UserEntity } from '@backstage/catalog-model';
import { JsonObject, JsonValue } from '@backstage/types';
import { Stakeholder } from '@internal/plugin-medidata-common';

import { useMedidataComponent } from '../../util';
import { StakeholderItem } from '../StakeholderItem';

export type StakeholderAndUser = {
  stakeholder: Stakeholder;
  user: UserEntity;
};

const getProperty = (
  profile: JsonValue | undefined,
  property: string,
): string => {
  if (profile === undefined) {
    return '';
  }
  const profileObj = profile as JsonObject;
  for (const entry of Object.entries(profileObj)) {
    if (entry[0] === property) {
      return entry[1] as string;
    }
  }
  return '';
};

const stakeholderAsUser = (
  stakeholder: Stakeholder,
  entities: Entity[],
): Entity | undefined =>
  entities.find(user => {
    if (user.kind !== 'User') {
      return undefined;
    }

    return (
      getProperty(user.spec?.profile, 'email').toLocaleLowerCase() ===
        stakeholder.email.toLocaleLowerCase() ||
      getProperty(user.metadata, 'secondaryEmail').toLocaleLowerCase() ===
        stakeholder.email.toLocaleLowerCase()
    );
  });

export const stakeholdersAsUsers = (
  stakeholders: Stakeholder[],
  entities: Entity[],
): StakeholderAndUser[] =>
  stakeholders.map(stakeholder => ({
    stakeholder: stakeholder,
    user: stakeholderAsUser(stakeholder, entities) as UserEntity,
  }));

export const StakeholdersCard = () => {
  const entity = useMedidataComponent();
  const stakeholders = entity.mdsol.stakeholders;

  if (!stakeholders) {
    return <Grid item />;
  }

  return (
    <InfoCard title="Experts">
      <Grid container spacing={1}>
        {stakeholders.map((stakeholder, i) => (
          <StakeholderItem stakeholder={stakeholder} key={i} />
        ))}
      </Grid>
    </InfoCard>
  );
};
